<template>
  <div class="messageShoppingListPage">  
    <XR-head titleText="购物通知" :rightShow="false" ref="head"></XR-head>
          
    <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" ref="scroll">
      <mu-list ref="list" v-for="msgItem in msgList" :key="msgItem.Id">
        <div class="date">{{msgItem.CreateDate}} <span style="padding-left: 10px;">购物通知</span></div>
          <mu-list-item class="head" :title="msgItem.MsTitle">

          </mu-list-item>
          <div class="detail">
              <div class="img">
                  <img :src="msgItem.ProdoctImg?msgItem.ProdoctImg:IMGServer_URL+'/images/index-item-default.png'" alt="">
              </div>
              <div class="product" ref="product" :style="{width: prowidth+'px'}">
                  <span v-html="msgItem.MsContext"></span>
              </div>
          </div>
          <mu-list-item class="lianjie" :title="msgItem.ButtonText?msgItem.ButtonText:'查看详情'" :to="msgItem.MsUrl" v-if="msgItem.MsUrl">
              <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
      </mu-list>
    </v-scroll>

    <!-- <ul>
      <li v-for="msgItem in msgList" :key="msgItem.Id">
        <div class="ms-date">{{msgItem.CreateDate}}</div>
        <div class="ms-title">
          <i class="fa fa-volume-down"></i>{{msgItem.MsTitle}}
        </div>
        <div class="ms-context">
          <div class="context-img"><img :src="msgItem.ProdoctImg"></div>
          <div :class="'context-value '+ (showMsgId==msgItem.Id?'show':'')"><span v-html="msgItem.MsContext"></span></div>
        </div>
        <div class="showAllContext" @click="showMsg(msgItem.Id)">{{showMsgId == msgItem.Id ? '点击收起消息内容':'点击查看完整消息'}}</div>
        <div class="btn">
          <a :href="msgItem.MsUrl">查看详情<i class="fa fa-angle-right"></i></a>
        </div>
      </li>
    </ul> -->
    
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>
<script>

export default {
  data () {
    return {
      pageEnd : 0, // 结束页数
      searchInfo:{
        type:2,
        pageIndex:1,
        pageSize:5
      },
      scrollDone:function(){},
      msgList : [],
      showMsgId:0
    }
  },
  mounted(){
    this.getMessageList(true)
  },
  methods: {
    getMessageList(isNewSearch){
       
      if(isNewSearch){        
        this.searchInfo.pageIndex=1
      }
      else{        
        this.searchInfo.pageIndex++
      }

      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserMessageTypeList", this.searchInfo
      ).then(function(res) {
        ths.scrollDone()
        if(!res.IsSuccess){          
          ths.$refs.XRPageTip.ShowEmpty(res.Msg)    
        }else{    
          ths.loaded =false          
          ths.$refs.XRtoast.hide()

          for(var i = 0; i <  res.Data.length; i++){
            res.Data[i].MsContext = decodeURIComponent(res.Data[i].MsContext)
          }
          
          if(isNewSearch){
            ths.msgList = res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.msgList.push(res.Data.List[i])
            }
          }

          ths.pageEnd = res.Data.Rows%ths.searchInfo.pageSize!=0? res.Data.Rows/ths.searchInfo.pageSize+1:res.Data.Rows/ths.searchInfo.pageSize

          if(!ths.msgList || ths.msgList.length<=0){            
            ths.$refs.XRPageTip.ShowEmpty(res.Msg)
          }else{            
            ths.$refs.XRPageTip.initTip()
          }

        }
      });      
    },
    showMsg(id){
      if(this.showMsgId == id){
        this.showMsgId = 0
      }else{
        this.showMsgId = id
      }
    },
    
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
       
        //this.$refs.XRtoast.failed("已经到最后一页", true)\
        this.$refs.scroll.infiniteDone()
        return
      }
      this.getMessageList(false);     
    }
  }
}

</script>


<style>
    .messageShoppingListPage .mu-list{
      background: #fff;
      margin-top: 15px;
      padding-top: 24px;
    }
    .messageShoppingListPage .mu-list .date{
      padding: 0 16px;
      color: #a3a3a3;
      font-size: 12px;
    }
    .messageShoppingListPage .mu-list .head .mu-item .mu-item-title{
      font-weight: bold;
      color: #000;
    }
    .messageShoppingListPage .mu-list .detail{
      width: 100%;
      display: flex;
      padding: 0 0;
      border-bottom: 1px solid #f5f5f5;
    }
    .messageShoppingListPage .mu-list .detail .img{
      width: 105px;
      float: left;
      margin-left: 16px;
    }
    .messageShoppingListPage .mu-list .detail .img img{
      width: 100%;
    }
    .messageShoppingListPage .mu-list .detail .product{
      float: left;
      margin: 0px 16px;
    }
    .messageShoppingListPage .mu-list .product .mu-item .mu-item-title{
      color: #333;
      font-size: 14px;
    }
    .messageShoppingListPage .mu-list .product .mu-item{
      min-height: auto;
      padding: 0;
    }
    .messageShoppingListPage .mu-list .mu-item .mu-item-content{
      line-height: 25px;
      color: #333;
      font-size: 14px;
    }
    .messageShoppingListPage .mu-list .lianjie .mu-item .mu-item-title{
      font-size: 14px;
    }
    .messageShoppingListPage .mu-list .lianjie .mu-item .mu-item-right{
      color: #eee;
    }

</style>




// WEBPACK FOOTER //
// src/pages/usercenter/messageShoppingList.vue